// extracted by mini-css-extract-plugin
module.exports = {"auth-page":"Signup_auth-page__ooGs7","auth-footer":"Signup_auth-footer__3sRz1","btn-container":"Signup_btn-container__2K3VZ","btn-link-terms":"Signup_btn-link-terms__2X4kw"};